import { useEffect, useState, useContext } from 'react';
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageProvider";
import Questions from '../components/Questions';
import { AnimatePresence, motion } from "framer-motion";

const AdvisorQuestionnaire = ({
  subGroup,
  validationErrors,
  setValidationErrors,
  inputRefs,
  handleInputBlur,
  language,
  setQuestions,
  firstLevelArea,
  secondLevelArea,
  subArea,
  inputBlurTriggered,
  savingQuestionId,
  fetchAreaNames,
  client,
  product,
  setIsDataSaved
}) => {
  const { t } = useContext(LanguageContext);
  const [showQuestions, setShowQuestions] = useState(false);

  const handleAddAdvisor = (event) => {
    event.preventDefault();
    setShowQuestions(true); // Show all questions when the button is clicked
  };

  const handleHideQuestions = async (event) => {
    event.preventDefault();

    // Check if all questions have null values
    const isAllNull = subGroup.subAreaCompositionDtoList.every(question => {
      const value = question.value;
      return value === null || value === undefined || String(value).trim() === '';
    });

    if (isAllNull) {
      // If all questions are null, just hide them without calling handleInputBlur
      setShowQuestions(false);
    } else {
      // Prepare a new list of questions with all values set to null
      const nullifiedQuestions = subGroup.subAreaCompositionDtoList.map(question => ({
        ...question,
        value: null,
      }));

      //console.log("Nullifying all questions before hiding", nullifiedQuestions);

      // Send the updated questions with null values to handleInputBlur
      await handleInputBlur(nullifiedQuestions);

      // Hide all questions after nullifying the values
      setShowQuestions(false);
    }
  };

  // Check if any questions have values and update visibility accordingly
  useEffect(() => {
    const isAnyQuestionFilled = subGroup.subAreaCompositionDtoList.some(question => {
      const value = question.value;
      return value !== null && value !== undefined && String(value).trim() !== '';
    });

    if (isAnyQuestionFilled) {
      setShowQuestions(true); // Show all questions if any have values
    } else {
      setShowQuestions(false); // Hide all questions if none have values
    }
  }, [subGroup]);

  return (
    <div className='second-advisor'>
      <div className="questions">
        <AnimatePresence mode="popLayout">
          {/* Render all questions only if showQuestions is true */}
          {showQuestions &&
            subGroup.subAreaCompositionDtoList.map((question, index) => (
              <motion.div
                key={`question-${question.uniqueId}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className={`${question.compositionType} ${question.uniqueId} ${question.code}`}
              >
                <Questions
                  key={question.uniqueId}
                  question={question}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  inputRefs={inputRefs}
                  setQuestions={setQuestions}
                  handleInputBlur={handleInputBlur}
                  firstLevelArea={firstLevelArea}
                  subArea={subArea}
                  secondLevelArea={secondLevelArea}
                  inputBlurTriggered={inputBlurTriggered}
                  savingQuestionId={savingQuestionId}
                  fetchAreaNames={fetchAreaNames}
                  client={client}
                  product={product}
                  language={language}
                  setIsDataSaved={setIsDataSaved}
                />
              </motion.div>
            ))}

          {showQuestions && (
            <motion.div
              key="hide-button"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="hide-advisor-button"
              onClick={handleHideQuestions}
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Prevent scrolling
                  handleHideQuestions(e);
                }
              }}
            >
              <i className="fa-regular fa-x"></i>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {!showQuestions && (
        <div className='add-advisor-button'>
          <Link to='#' onClick={handleAddAdvisor}>{t('add_an_advisor')}</Link>
        </div>
      )}
    </div>
  );
};

export default AdvisorQuestionnaire;
